<template>
  <el-popover placement="top" :width="12*message.length" v-model="visible">
    <p style="color:red">{{message}}</p>
    <div style="text-align: right; margin: 0">
      <el-button size="mini" type="text" @click="visible = false;$emit('cancel')">άκυρο</el-button>
      <el-button type="danger" size="mini" @click="visible = false;$emit('go')">κάντο</el-button>
    </div>
    <el-button slot="reference" style="margin-left:3px;" :type="type">
      <i class="material-icons">delete_forever</i>
    </el-button>
  </el-popover>
</template>

<script>
export default {
  name: "s-btn-delete",
  methods: {
    // go(e) {
    //   if (!this.confirm) this.$emit("execute", e);
    //   else
    //     this.$confirm(this.confirm, "Warning", {
    //       confirmButtonText: "OK",
    //       cancelButtonText: "Cancel",
    //       type: "warning"
    //     })
    //       .then(() => {
    //         this.$emit("execute", e);
    //       })
    //       .catch(() => {
    //         this.$emit("cancel", e);
    //       });
    // }
  },
  data() {
    return {
      visible: false
    };
  },
  props: {
    // right: {
    //   type: Boolean,
    //   default: false
    // },
    type: {
      type: String,
      default: "danger"
    },
    message: {
      type: String,
      default: "Σίγουρα?"
    }
    // loading: {
    //   type: Boolean,
    //   default: false
    // },
    // disabled: {
    //   type: Boolean,
    //   default: false
    // },
    // round: {
    //   type: Boolean,
    //   default: false
    // },
    // circle: {
    //   type: Boolean,
    //   default: false
    // },

    // size: {
    //   type: String,
    //   default: null
    // }
  }
};
</script>
